import makeStyles from '@mui/styles/makeStyles';

import { borderColor, darkGray, surfaceElevated, teal900 } from '@/theme/colors';

export const useStyles = makeStyles({
  stepper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '16px 24px',
    backgroundColor: surfaceElevated,
    borderBottom: `1px solid ${borderColor}`,
  },
  stepContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  step: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  stepCircle: {
    width: 32,
    height: 32,
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 14,
    fontWeight: 500,
  },
  stepCircleActive: {
    backgroundColor: teal900,
    color: 'white',
  },
  stepCircleInactive: {
    backgroundColor: borderColor,
    color: darkGray,
  },
  stepLabel: {
    fontSize: 12,
    marginTop: 4,
  },
  stepLabelActive: {
    color: 'var(--brandPrimary)',
  },
  stepLabelInactive: {
    color: '#9CA3AF',
  },
  stepConnector: {
    width: 64,
    height: 2,
    marginLeft: 8,
    marginRight: 8,
    marginBottom: 20,
  },
  stepConnectorActive: {
    backgroundColor: teal900,
  },
  stepConnectorInactive: {
    backgroundColor: borderColor,
  },
});
